export const AGREEMENT_PARAMETER_TYPE_POINT = 'point';
export const AGREEMENT_PARAMETER_TYPE_TEXT = 'text';
export const AGREEMENT_PARAMETER_TYPE_SUBHEADER = 'subHeader';
export const HOME_INSURED_OWU_DELIVERED_CODE = 'HOME_INSURED_OWU_DELIVERED';

export const OWU_NOT_APPLICABLE_INSURERS = ['generali', 'proama'];
